import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {XwaysHoarder2Statics} from "../XwaysHoarder2Statics";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {XwaysHoarder2GameAssets} from "../XwaysHoarder2GameAssets";
import {SpineGSAPWrapper} from "../utils/SpineGSAPWrapper";
import Animation = PIXI.spine.core.Animation;
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {MaxWinView} from "./MaxWinView";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {BitmapText} from "pixi.js";
import {BasicSymbol} from "../reels/symbols/BasicSymbol";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

enum SpineTracks {
    TEXT_LOOP,
    LEVEL_LOOP,
    LEVEL_START
}


export class WinView extends PIXI.Container implements StageLayer {
    private countUp: BasicBitmapCountUp;
    private countContainer: PIXI.Container;

    private bigWin: PIXI.spine.Spine;
    private bwAnimations: Animation [] = [];

    private maxWin : MaxWinView;


    private _waysWonCounter: PIXI.Text;
    private _waysWonText: PIXI.Text;
    private _wayWonTextStyle: PIXI.TextStyle = new PIXI.TextStyle({
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 1,
        dropShadowDistance: 3,
        fontSize: 40,
        dropShadowColor: "#000000",
        fill: "#ffffff",
        fontFamily: OpenSans.FAMILY,
        fontStyle: "italic",
        fontWeight: FontWeight.BOLD,
        stroke: 0x000000,
        strokeThickness: 4,
        lineJoin: "round"
    });
    private _waysWonString: string;
    private _wayWonString: string;
    private winEffect: TimelineSprite | null;


    constructor() {
        super();
        this.name = "WinView";
        this.init();
    }

    public getWinCountUp(from: number, to: number, duration: number, ways: number = 0,
                         pos: PIXI.Point = new PIXI.Point(360, 360), scale:number,sound: boolean = true)
        : gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        this.countContainer.position.set(pos.x, pos.y);
        this.countUp.scale.set(scale,scale);
        tl.add(() => {
            this.countContainer.alpha = 1;
            this.addChild(this.countContainer);
            this.addChild(this._waysWonText, this._waysWonCounter);
        },0);

        if (sound) {
            tl.add(() => {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.COUNTUP);
            });
        }

        tl.add(this.countUp.getCountAnimation(from, to, duration));

        tl.add(() => {
            this.countUp.stopAt(to, false);
        });

        return tl;
    }

    public getWinCountUpEnd(accumulatedRoundWin: number, stayDuration: number, ways: number = 0, endSound: string = "", playFx:boolean = false, winType: string = "") {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            if (!XwaysHoarder2.isWinBelowStake()) {
                XwaysHoarder2Sound.playTrack(endSound);
            }

            if(!XwaysHoarder2.isWinBelowStake() && this.winEffect && playFx) {

                if(winType === "MEDIUM") {
                    this.winEffect.scale.set(1.3, 1.3);
                }
                else if (winType === "LARGE") {
                    this.winEffect.scale.set(1.65, 1.65);
                }



                if(!this.skipped) {
                        if (this.winEffect && !this.skipped) {
                            if (winType === "MEDIUM") {
                                tl.add(XwaysHoarder2.screenShake(0.1, 30, false, 5), stayDuration - 0.3)
                            } else if (winType === "LARGE") {
                                tl.add(XwaysHoarder2.screenShake(0.2, 75, false, 15), stayDuration - 0.3)
                            }

                            this.winEffect.getAnimationAutoShowHide();
                        }
                }
            }
        });
        tl.add(() => {
            this.countUp.stopAt(accumulatedRoundWin, false);
        });

        tl.add(gsap.to(this, {duration: stayDuration}));

        return tl;
    }

    public getWinCountUpFade(accumulatedRoundWin: number, fadeDuration: number = 0.3) {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add([
            gsap.to([this.countContainer, this._waysWonCounter, this._waysWonText], {
                duration: fadeDuration,
                alpha: 0,
                ease: "none"
            }),
            gsap.to(this.countContainer.position, {
                duration: fadeDuration,
                y: this.countContainer.position.y - 360,
                ease: "none"
            }),
            gsap.to([this._waysWonCounter.position, this._waysWonText.position], {
                duration: fadeDuration,
                y: this._waysWonCounter.position.y - 360,
                ease: "none"
            })
        ]);
        tl.add(() => {
            this.countContainer.alpha = 0;
            this.countContainer.position.set(0, 0);
        });

        return tl;
    }

    public getBigWinAnimation(level: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        //tl.add(() => this.startLoopAnimations(level));

        tl.add(() => {
            this.bigWin.visible = true;
            this.bigWin.alpha = 1;
        })

        // For every level, play 2 anims (intro and regular)
        // console.log("Setting up BW animations", this.bwAnimations[level].name, this.bwAnimations[level + 1].name);
        tl.add(SpineGSAPWrapper.createTimeline(this.bigWin, 0, this.bwAnimations[level + 1].name));
        tl.add(SpineGSAPWrapper.createTimeline(this.bigWin, 0, this.bwAnimations[level].name));

        tl.totalDuration(5);
        return tl;
    }

    public getBigWinEnd(stayDuration: number = 1): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.BIGWIN_END);
            XwaysHoarder2Sound.fadeMusic(1, 100);
        });
        // tl.add(() => SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.EXPLOSION, "depthChargeExplosionStartingLevel"));
        tl.add(gsap.to(this, {duration: stayDuration - 0.3}));
        tl.add(gsap.to(this.bigWin, {duration: 0.3, alpha: 0, ease: "none"}));
        tl.add(() => this.clearBigWinSpine(), "+=0.01");


        return tl;
    }

    public hideBigwin(): gsap.core.Timeline {
        const hideTl: gsap.core.Timeline = gsap.timeline();
        hideTl.to(this.bigWin, {duration: 0.3, alpha: 0, ease: "none"});
        hideTl.add(() => this.clearBigWinSpine(), "+=0.01");
        return hideTl;
    }

    public setWaysWonText(triggeredFromBigWin:boolean): gsap.core.Timeline {
        let count: number = 0;
        const yPos: number = this.countContainer.position.y + (this.countUp.height) / 2 + (triggeredFromBigWin?0:20);
        const waysTl: gsap.core.Timeline = gsap.timeline();

        XwaysHoarder2.model.gameData.betWayWins.forEach((betway: IBetWayWinData) => {
            count += betway.numberOfCombinations;
        });
        if (count > 0) {
            if (count === 1) {
                this._waysWonText.text = this._wayWonString;
            } else {
                this._waysWonText.text = this._waysWonString;
            }
        }

        this._waysWonCounter.text = count.toString();
        this._waysWonCounter.position.set(360 - this._waysWonText.width * 0.5, yPos);
        this._waysWonText.position.set(this._waysWonCounter.position.x + this._waysWonCounter.width + this._waysWonText.width * 0.5, yPos);

        waysTl.to([this._waysWonCounter, this._waysWonText], {alpha: 1, duration: 0.65}, 0);
        waysTl.fromTo([this._waysWonText, this._waysWonCounter], {y: yPos - 40}, {
            y: yPos,
            duration: 0.65,
            ease: "Back.easeOut"
        }, 0);

        return waysTl;
    }

    private init() {
        this.countUp = new BasicBitmapCountUp(XwaysHoarder2Statics.WIN_COUNT_UP, 680, new PIXI.Point(0.5, 0.5));
        this.countUp.position.set(0, 0);
        this.countUp.name = "countup";

        this.countContainer = new PIXI.Container();
        this.countContainer.name = "countupcontainer";
        this.countContainer.position.set(360, 280);
        this.countContainer.alpha=0;
        this.countContainer.addChild(this.countUp);

        this.bigWin = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.BIG_WIN_SPINE));
        this.bigWin.position.set(360, 360);
        this.bigWin.visible = false;
        this.bigWin.name = "bigwin spine";
        this.addChild(this.bigWin);
        this.bigWin.spineData.animations.forEach((anim) => {
            this.bwAnimations.push(anim);
        });
        // console.log("BW SPINE: ", this.bigWin.spineData.animations);

        this.winEffect = new TimelineSprite(XwaysHoarder2.assetLoader.getTextures("winFx"));
        this.winEffect.anchor.x = 0.5;
        this.winEffect.position.set(360, 220);
        this.winEffect.blendMode = PIXI.BLEND_MODES.SCREEN;
        this.winEffect.visible = false;
        this.addChild(this.winEffect);

        this.addChild(this.countContainer);

        this._waysWonCounter = new PIXI.Text("", this._wayWonTextStyle);
        this._waysWonCounter.anchor.set(0.5, 0.5);
        this._waysWonCounter.alpha = 0;
        this._waysWonText = new PIXI.Text("", this._wayWonTextStyle);
        this._waysWonText.anchor.set(0.5, 0.5);
        this._waysWonText.alpha = 0;
        this.addChild(this._waysWonText, this._waysWonCounter);

        this._waysWonText.name="ways Won TExt";
        this._waysWonCounter.name="ways won count";
        this._waysWonString = XwaysHoarder2.apiPlugin.translations.translate("Ways Won");
        this._wayWonString = XwaysHoarder2.apiPlugin.translations.translate("Way Won");
        //this.testAllBwAnimations();

        this.maxWin= new MaxWinView();
        this.addChild(this.maxWin);
    }

    private getStartPosition(symPosition: number[]): number[] {
        let reelId = symPosition[0],
            symId = symPosition[1];
        let posX = (XwaysHoarder2Statics.symbolWidth * reelId),
            posY = (XwaysHoarder2Statics.symbolHeight * symId) + 240;
        if (reelId === 0 || reelId === 4) {
            posY = (124 * symId) + 124 + 124;
        }
        /*if (XwaysHoarder2.model.data.mode === XW2GameMode.FREESPIN_SUPER) {
            posX = (114 * reelId) + 85;
            posY = (90 * symId) + 90;
            if (reelId === 0 || reelId === 5) {
                posY = (90 * symId) + 90 + 90;
            }
        }*/
        return [posX, posY];
    }

    public findLastNoWildSymbolPosition(betWayWinData: IBetWayWinData): number[] {
        for (let reelId = 2; reelId > -1; reelId--) {
            for (let symId = 0; symId < 3; symId++) {
                if (!betWayWinData.reelWinPositions[reelId][symId]) {
                    continue;
                }
                let sym: BasicSymbol;

                sym = <BasicSymbol>XwaysHoarder2.reelView.reels[reelId].model.getVisibleSymbolAt(symId).positionable;
                if (sym && sym.symbolName === "W" || sym.symbolName === "XS" || sym.symbolName === "XN") {
                    continue;
                } else {
                        //continue
                }


                return [reelId, symId];
            }
        }
        return [0, 0];
    }

    private _wayWonTextStyleIW: PIXI.TextStyle = new PIXI.TextStyle({
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 1,
        dropShadowDistance: 3,
        fontSize: 12,
        dropShadowColor: "#000000",
        fill: "#ffffff",
        fontFamily: OpenSans.FAMILY,
        fontStyle: "italic",
        fontWeight: FontWeight.BOLD,
        stroke: 0x000000,
        strokeThickness: 4,
        lineJoin: "round"
    });

    public playWinNumbers(betWayWinData: IBetWayWinData, skipped: boolean, symPosition: number[]): gsap.core.Timeline {
        const timeline: gsap.core.Timeline = gsap.timeline();

        let text: string = XwaysHoarder2.apiPlugin.currency.formatValue(MathHelper.roundToDecimals(betWayWinData.amount, 2)),
            totalWinWays: number = betWayWinData.numberOfCombinations;
        if (betWayWinData.multiplier > 1) {
            text += ` x ${betWayWinData.multiplier}`;
        }
        const textHolder: PIXI.Container = new PIXI.Container();
        const winNumber: PIXI.BitmapText = new PIXI.BitmapText(text, {
                fontName: XwaysHoarder2GameAssets.WIN_COUNT_UP,
                fontSize: 12
            }),
            waysNumber: PIXI.BitmapText = new BitmapText(totalWinWays.toString(), {
                fontName: XwaysHoarder2GameAssets.WIN_COUNT_UP,
                fontSize: 9
            });
        winNumber.anchor = new PIXI.Point(0.5, 0.5);
        winNumber.position.set(0, 0);
        waysNumber.anchor = new PIXI.Point(0.5, 0.5);
        const waysSprite:PIXI.Text = new PIXI.Text((totalWinWays > 1)? XwaysHoarder2.apiPlugin.translations.translate("Ways") : XwaysHoarder2.apiPlugin.translations.translate("Way"), this._wayWonTextStyleIW);
        waysNumber.alpha = 0;
        textHolder.alpha = 0;
        textHolder.addChild(winNumber);
        this.addChildAt(textHolder, 0);
        this.addChildAt(waysNumber, 0);
        this.addChildAt(waysSprite, 0);
        winNumber.updateTransform();

        const sym = <BasicSymbol>XwaysHoarder2.reelView.reels[0].model.getVisibleSymbolAt(symPosition[1]).positionable;
        const startPositions: number[] = this.getStartPosition(symPosition);
        if(sym) {
            if(symPosition[1] === 0) {
                startPositions[1] = XwaysHoarder2Statics.symbolHeight;
                //startPositions[1] -= XwaysHoarder2Statics.symbolHeight / 2;
            }
            else if(symPosition[1] === 1) {
                startPositions[1] = XwaysHoarder2Statics.symbolHeight * 2;
                //startPositions[1] += XwaysHoarder2Statics.symbolHeight / 3.5;
            }
            else if (symPosition[1] === 2) {
                startPositions[1] = XwaysHoarder2Statics.symbolHeight * 3;
                //startPositions[1] += XwaysHoarder2Statics.symbolHeight / 4;
            }
        }

        let portraitOffset:number = 0;
        if(symPosition[0] === 0 && !NolimitApplication.isLandscape) {
            portraitOffset = 35;
        }

        textHolder.position.set(startPositions[0] + portraitOffset, startPositions[1]);
        waysNumber.position.set(startPositions[0] + portraitOffset, startPositions[1] + 32);
        waysSprite.position.set(startPositions[0] + (waysNumber.width / 2) + portraitOffset, startPositions[1] + 30);
        timeline.add(gsap.to([textHolder, waysNumber, waysSprite], {duration: 0.1, alpha: 1}), 0);
        timeline.add(gsap.to([textHolder, waysNumber, waysSprite], {duration: 0.1, alpha: 0, delay: 0}), ">0.6");
        timeline.add(() => {
            if (winNumber.parent) {
                this.removeChild(winNumber);
            }
            winNumber.destroy();
            if (waysNumber.parent) {
                this.removeChild(waysNumber);
            }

            waysSprite.destroy();
            if (waysSprite.parent) {
                this.removeChild(waysSprite);
            }
            textHolder.destroy();
        });
        if (skipped) {
            this.skipped = true;
            timeline.timeScale(4);
        }


        return timeline;
    }

    public skipped: boolean = false;

    private startLoopAnimations(level: number) {
        //SpineGSAPWrapper.createTimeline(this.bigWin, SpineTracks.TEXT_LOOP, "textLoop", -1);
        //SpineGSAPWrapper.createTimeline(this.bigWin, SpineTracks.LEVEL_LOOP, `level${level}Idle`, -1);
    }

    private testAllBwAnimations(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({repeat: -1});
        this.bigWin.visible = true;
        this.bigWin.alpha = 1;

        this.bwAnimations.forEach((anim) => {
            tl.add(SpineGSAPWrapper.createTimeline(this.bigWin, 0, anim.name));
        });

        return tl;
    }

    private clearBigWinSpine() {
        SpineGSAPWrapper.createTimeline(this.bigWin, 0, null);

        this.bigWin.visible = false;
        this.bigWin.alpha = 1;
    }


    public showWinCap():gsap.core.Timeline{
        return this.maxWin.showMaxWin();
    }

    public showWinCapTimes():gsap.core.Timeline{
        return this.maxWin.showWinCapTimes();
    }

    public hideWinCap():gsap.core.Timeline{
        return this.maxWin.hideMaxwin();
    }

}